var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKemitraanYangFleksibel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.906,
    viewBox: "0 0 104 128.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1292 -331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(1292 331)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1305.472 102.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.346,280.6H71.329a6.384,6.384,0,0,1,6.4,6.4v49.332a6.384,6.384,0,0,1-6.4,6.4H7.346a6.384,6.384,0,0,1-6.4-6.4V286.994a6.384,6.384,0,0,1,6.4-6.4Z",
    transform: "translate(-0.948 -280.596)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07,282.677H42.283a4.552,4.552,0,0,1,4.562,4.562v19.2A4.552,4.552,0,0,1,42.283,311H9.07a4.552,4.552,0,0,1-4.562-4.562v-19.2A4.552,4.552,0,0,1,9.07,282.677Z",
    transform: "translate(12.713 -272.611)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.829,282.677v8.163a2.138,2.138,0,0,0,2.144,2.141H15.9a2.138,2.138,0,0,0,2.144-2.141v-8.163Z",
    transform: "translate(25.452 -272.61)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.316,287.682A2.56,2.56,0,0,0,8.3,291.818H29.919a4.552,4.552,0,0,0,4.459-4.141Z",
    transform: "translate(25.164 -253.429)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006 46.792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3,10.2H.53V15.32H66.3C69.795,15.32,70.7,10.2,66.3,10.2Z",
    transform: "translate(-0.53 -10.204)",
    fill: "#bfd2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.53,11.03v5.034a6.394,6.394,0,0,0,6.408,6.408H31.273v4.946s-12.008.517-12.008,9.728H58.7c0-9.21-12.008-9.728-12.008-9.728V22.473H71.022a6.394,6.394,0,0,0,6.408-6.408V11.03Z",
    transform: "translate(-0.53 -7.032)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.353,13.158a2.564,2.564,0,1,0,0,5.127h8.7V13.158Z",
    transform: "translate(27.1 1.128)",
    fill: "#a29292"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKemitraanYangFleksibel);
export default __webpack_public_path__ + "static/media/kemitraan-yang-fleksibel.9bc39e2b2ec0ef47e0adb5aac29379a2.svg";
export { ForwardRef as ReactComponent };